import { ToursList } from '@/components/tours';
import { tourCrudConfig, type Tour } from '@/config/objects/tours';
import { useApiClient, type CrudConfig } from '@startupquickstart/frontend';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from '@startupquickstart/frontend';

export function GreaterAreaToursTab() {
  const { id } = useParams<{ id: string }>();
  const apiClient = useApiClient();

  const config: CrudConfig<Tour> = useMemo(
    () => ({
      ...tourCrudConfig,
      entityName: 'Tour',
      entityNamePlural: 'Tours',
      endpoints: {
        ...tourCrudConfig.endpoints,
        list: `/greater-areas/${id}/tours`,
        delete: (tourId: string) => `/greater-areas/${id}/tours/${tourId}`,
      },
      listView: {
        ...tourCrudConfig.listView,
        actions: {
          add: {
            enabled: true,
            endpoint: '/tours',
            where: {
              greaterAreaId: {
                not: id,
              },
            },
            onAdd: async (tour: Tour) => {
              await apiClient.post(`/greater-areas/${id}/tours`, { tourId: tour.id });
              toast.success('Tour added to greater area');
            },
          },
          view: {
            enabled: true,
          },
          remove: {
            enabled: true,
            onRemove: async (tour: Tour) => {
              await apiClient.delete(`/greater-areas/${id}/tours/${tour.id}`);
              toast.success('Tour removed from greater area');
            },
          },
        },
      },
    }),
    [id, apiClient],
  );

  if (!id) return null;

  return <ToursList config={config} className="p-0" baseUrl="/tours" />;
}
